import React from 'react'
import { Link } from 'react-router-dom';

import './rewardDesc.css'
import QR from '../assets/rewardDesc/qr.png';
import QR2 from '../assets/rewardDesc/qr2.png';
import playstore from '../assets/rewardDesc/playstore.png';
import playstore2 from '../assets/rewardDesc/playstore2.png';

const rewardDesc = () => {
    return (
        <>
            <div className="hero-reward">
                <div className="container reward-head">
                    <h2>Reward Pro</h2>
                    <p>Introducing Reward Pro, a user friendly Android app designed to help you earn coins effortlessly by completing various tasks, including playing games, watching videos, and referring friends. These coins can be conveniently redeemed as Paytm cash, providing you with a seamless way to access your hard-earned rewards. With Reward Pro, maximizing your earnings has never been easier. Experience the simplicity and convenience of transforming your efforts into tangible rewards with Reward Pro.
                        Download the app now and unlock a world of possibilities to monetize your time effectively and professionally.
                    </p>
                    {/* <h3>Download our app today and start earning money right away!</h3> */}
                    <div className="reward-img">
                        <a href="">
                            <img src={QR2} alt="" className="btn-zoom" style={{ width: "170px" }} />
                        </a>
                    </div>
                    <div className="reward-img">
                        <a href="">
                            <img src={playstore2} alt="" className="btn-zoom" style={{ width: "170px" }} />
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default rewardDesc
